// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickJournalChromaFlare__lower___xYEAb, .QuickJournalChromaFlare__upper___mg4YN {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
}

.QuickJournalChromaFlare__lower___xYEAb {
    isolation: isolate;
    contain: layout paint;
}

/* A static overlay avoids re-rasterizing a full-panel mask over moving glass. */
.QuickJournalChromaFlare__lower___xYEAb::after {
    content: "";
    position: absolute;
    z-index: 10;
    inset: 0;
    background: linear-gradient(#302c25, transparent 13%, transparent 72%, #181919);
    pointer-events: none;
}

.QuickJournalChromaFlare__lower___xYEAb .QuickJournalChromaFlare__scene___A7CnL {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    max-width: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    opacity: .65;
}

.QuickJournalChromaFlare__lower___xYEAb .QuickJournalChromaFlare__scene___A7CnL::before { opacity: .12; }

.QuickJournalChromaFlare__lower___xYEAb .QuickJournalChromaFlare__scene___A7CnL [data-chroma-softlight] {
    background: radial-gradient(ellipse, rgba(239, 218, 185, .18), transparent 70%);
}

.QuickJournalChromaFlare__lower___xYEAb .QuickJournalChromaFlare__scene___A7CnL [data-chroma-caustic] {
    background: radial-gradient(ellipse, rgba(255, 225, 172, .25), transparent 70%);
}
.QuickJournalChromaFlare__lower___xYEAb .QuickJournalChromaFlare__scene___A7CnL [data-chroma-caustic]::after { display: none; }

/* Keep every facet and its motion, but avoid live backdrop sampling and
   filtered/blended offscreen surfaces. Same rendering path on every device. */
.QuickJournalChromaFlare__lower___xYEAb .QuickJournalChromaFlare__scene___A7CnL *, .QuickJournalChromaFlare__lower___xYEAb .QuickJournalChromaFlare__scene___A7CnL *::before, .QuickJournalChromaFlare__lower___xYEAb .QuickJournalChromaFlare__scene___A7CnL *::after,
.QuickJournalChromaFlare__lower___xYEAb .QuickJournalChromaFlare__scene___A7CnL::before {
    -webkit-backdrop-filter: none !important;
    backdrop-filter: none !important;
    filter: none !important;
    mix-blend-mode: normal;
}

.QuickJournalChromaFlare__upper___mg4YN { z-index: 0; }

.QuickJournalChromaFlare__upper___mg4YN::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
        radial-gradient(ellipse at 9% 61%, rgba(245, 211, 145, .15), transparent 42%),
        radial-gradient(ellipse at 89% 18%, rgba(206, 224, 242, .12), transparent 44%);
}

.QuickJournalChromaFlare__glassLeft___p3Ktf, .QuickJournalChromaFlare__glassRight___IO11R {
    position: absolute;
    display: block;
    width: 32%;
    height: 64%;
    opacity: .65;
    clip-path: polygon(0 20%, 90% 0, 100% 76%, 10% 100%);
    background: linear-gradient(115deg, rgba(237, 233, 222, .22), transparent 43%, rgba(206, 214, 228, .16));
    animation: QuickJournalChromaFlare__glassDrift___dehzV 24s ease-in-out infinite alternate;
}

.QuickJournalChromaFlare__glassLeft___p3Ktf { left: -12%; top: 12%; transform: rotate(-16deg); }
.QuickJournalChromaFlare__glassRight___IO11R { right: -12%; top: -20%; transform: rotate(18deg); animation-delay: -12s; }

.QuickJournalChromaFlare__refraction___iolmE {
    position: absolute;
    display: block;
    inset: 0;
    opacity: .65;
    background: linear-gradient(116deg, transparent 13%, rgba(186, 213, 223, .1) 20%, rgba(232, 212, 177, .16) 22%, rgba(219, 177, 192, .12) 23%, transparent 29%);
    animation: QuickJournalChromaFlare__lightDrift___aon9s 32s ease-in-out infinite alternate;
}

.QuickJournalChromaFlare__facet___EwVrL {
    position: absolute;
    display: block;
    aspect-ratio: .57;
    clip-path: polygon(44% 0, 100% 28%, 57% 100%, 0 71%);
    background: linear-gradient(145deg, rgba(255, 246, 222, .48), rgba(218, 228, 236, .06) 46%, rgba(255, 234, 188, .28) 49%, rgba(187, 213, 227, .1));
    animation: QuickJournalChromaFlare__facetFloat___kVM6N 19s ease-in-out infinite alternate;
}

.QuickJournalChromaFlare__facet___EwVrL::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(160deg, transparent 37%, rgba(188, 212, 239, .3) 43%, rgba(219, 193, 217, .23) 48%, rgba(239, 217, 163, .35) 53%, transparent 60%);
}

.QuickJournalChromaFlare__glint___hhli9 {
    position: absolute;
    display: block;
    left: 15%;
    top: 66%;
    width: 88px;
    height: 88px;
    background: radial-gradient(circle, #fff6d8 0 1px, rgba(255, 224, 153, .6) 2px, rgba(255, 214, 128, .13) 8px, transparent 40px);
    animation: QuickJournalChromaFlare__upperGlint___N5KqC 23s ease-in-out infinite;
}

.QuickJournalChromaFlare__glint___hhli9::after {
    content: "";
    position: absolute;
    inset: 50% -26%;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 232, 182, .6), transparent);
    transform: rotate(-24deg);
}

.QuickJournalChromaFlare__upper___mg4YN[data-paused] *, .QuickJournalChromaFlare__scene___A7CnL[data-paused] *,
.QuickJournalChromaFlare__scene___A7CnL[data-paused] *::before, .QuickJournalChromaFlare__scene___A7CnL[data-paused] *::after,
.QuickJournalChromaFlare__scene___A7CnL[data-paused]::before { animation-play-state: paused !important; }

@keyframes QuickJournalChromaFlare__glassDrift___dehzV {
    from { translate: -5px 0; }
    to { translate: 8px 12px; }
}

@keyframes QuickJournalChromaFlare__lightDrift___aon9s {
    from { transform: translateX(-4%); opacity: .4; }
    to { transform: translateX(8%); opacity: .8; }
}

@keyframes QuickJournalChromaFlare__facetFloat___kVM6N {
    from { transform: translate(-4px, 8px) rotate(-8deg); opacity: .32; }
    to { transform: translate(7px, -12px) rotate(6deg); opacity: .7; }
}

@keyframes QuickJournalChromaFlare__upperGlint___N5KqC {
    0%, 100% { transform: translate(-12px, 8px); opacity: .15; }
    45% { transform: translate(10px, -18px); opacity: .75; }
    72% { transform: translate(3px, -4px); opacity: .3; }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lower": `QuickJournalChromaFlare__lower___xYEAb`,
	"upper": `QuickJournalChromaFlare__upper___mg4YN`,
	"scene": `QuickJournalChromaFlare__scene___A7CnL`,
	"glassLeft": `QuickJournalChromaFlare__glassLeft___p3Ktf`,
	"glassRight": `QuickJournalChromaFlare__glassRight___IO11R`,
	"glassDrift": `QuickJournalChromaFlare__glassDrift___dehzV`,
	"refraction": `QuickJournalChromaFlare__refraction___iolmE`,
	"lightDrift": `QuickJournalChromaFlare__lightDrift___aon9s`,
	"facet": `QuickJournalChromaFlare__facet___EwVrL`,
	"facetFloat": `QuickJournalChromaFlare__facetFloat___kVM6N`,
	"glint": `QuickJournalChromaFlare__glint___hhli9`,
	"upperGlint": `QuickJournalChromaFlare__upperGlint___N5KqC`
};
module.exports = ___CSS_LOADER_EXPORT___;
